// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mQghv","right":"styles_right__2pIFi"};